import {timeQuery} from 'helpers/Utils'
import {User} from '../Users/Model'
import OperationLine from '../OperationLines/Model'
import Stretch from '../Stretches/Model'

export class Invoice {
  id: number
  number: string
  date: Date
  netAmount: number
  discount: number
  taxBase: number
  taxAmount: number
  total: number

  constructor(props: Invoice) {
    Object.assign(this, props)
    this.date = new Date(props.date)
  }
}

export class CashDesk {
  id: number
  cashAmount: number
  cardAmount: number
  state: CashDeskState
  date: Date

  constructor(props: CashDesk) {
    Object.assign(this, props)
    this.date = new Date(props.date)
  }
}

export const CashDeskState = {
  open: 'open',
  close: 'close',
  partialClose: 'partialClose'
}

export type CashDeskState = string

export class Ticket {
  id: number
  numero: string
  datebook: Date
  datecheck: Date
  user_id: number
  username: string
  netAmount: number
  discount: number
  taxAmount: number
  total: number
  terminal: string
  daterefund: Date
  businessUnit: string
  businessunit_id: number
  operationLine_id: number
  operationLine: OperationLine | string
  stretch_id: number
  stretch: Stretch | string
  datevalited: Date | string
  codeDiscount: string
  vuelta: boolean
  numberPrinted: number
  tin: number
  image: string
  hoponHopoff: boolean
  timeExpiration: number
  tramoHora: boolean

  constructor(props: any) {
    Object.assign(this, props)
    const user: User = new User(props.user)
    this.username = props.username !== undefined ? props.username : user.username
    this.businessUnit = props.operationLine.businessUnit.name
    this.tin = props.operationLine.businessUnit.tin
    this.image = props.operationLine.businessUnit.image
    this.operationLine = props.operationLineName !== undefined? props.operationLineName : props.operationLine.name// new OperationLine(props.operationLine)
    this.stretch = props.stretchName !== undefined? props.stretchName : props.stretch.name // new Stretch(props.stretch)
    this.datecheck = new Date(props.datecheck)
    this.datebook = new Date(props.datebook)
    this.datevalited = props.datevalited? new Date(props.datevalited) : ''
    this.daterefund = props.daterefund === null? null : new Date(props.daterefund)
  }
}

export class TicketCashDesk {
  id: number
  dateOpen: Date
  dateClose: Date
  printedTickets: object
  bookingTickets: object
  refundTickets: object
  user_id: number
  username: string
  terminalBrand: string
  terminalSN: string
  tickets: number
  checkins: number
  total: number
  totalDiscount: number
  totalRefund: number
  lines: TicketCashDeskLine[]

  constructor( values: any ) {
    Object.assign( this, values )
    this.dateOpen = new Date( values.dateOpen )
    this.dateClose = new Date( values.dateClose )
  }
}

export class TicketCashDeskLine {
  id: number
  ticketCashDesk_id: number
  quantity: number
  passengerCategory: string
  operationLine: string
  stretch: string
  total: number
  money: string

  constructor( values: any ) {
    Object.assign(this, values)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/Model.ts